export const BASE_URL = 'https://xgenious.com';
export const CANONICAL = `${BASE_URL}/products/xilancer-freelancer-marketplace-script`;
export const COLOR = '#e8705a';
export const LIGHT_COLOR = '#fef3f0';
export const PURCHASE_URL = 'https://codecanyon.net/item/xilancer-freelancer-marketplace-platform-with-services-projects/49358326';
export const DEMO_URL = 'https://xilancer.xgenious.com';
export const ADMIN_URL = 'https://xilancer.xgenious.com/admin';
export const DOCS_URL = 'https://docs.xgenious.com/docs/xilancer-freelancer-marketplace/';
export const MOBILE_URL = '#mobile-apps';
export const PRICING_URL = '#pricing';
export const REGULAR_PRICE = 59;
export const BUNDLE_PRICE = 99;
export const BUNDLE_PRODUCT_PATH = 'xilancer-bundle-pack';
export const EXCLUSIVE_PRICE = 299;
export const EXCLUSIVE_PRODUCT_PATH = 'xilancer-exclusive-pack';

export const QUICK_LINKS = [
  { label: 'Admin Panel', href: ADMIN_URL },
  { label: 'Mobile App', href: MOBILE_URL },
  { label: 'Documentation', href: DOCS_URL },
  { label: 'Pricing', href: PRICING_URL },
];

export const STATS = [
  { value: '450+', label: 'Active installs' },
  { value: '4.36/5', label: 'CodeCanyon rating' },
  { value: '45', label: 'Verified reviews' },
  { value: '1-time', label: 'Purchase' },
];

export const TECH = [
  { name: 'Laravel', desc: 'PHP 8+ backend framework' },
  { name: 'Vue.js', desc: 'Reactive SPA frontend' },
  { name: 'MySQL', desc: 'Relational database' },
  { name: 'Laravel Echo', desc: 'Real-time WebSocket events' },
  { name: 'Flutter', desc: 'Cross-platform mobile app' },
  { name: 'Stripe & PayPal', desc: 'Escrow payment processing' },
];

export const REVIEWS = [
  {
    name: 'Aofn75',
    category: 'Customer Support',
    rating: 5,
    body: 'One of the best and fast customer support I have ever seen. Very humble and they fix any issues within no time. Highly recommended.',
  },
  {
    name: 'Sommapropaganda',
    category: 'Customer Support',
    rating: 5,
    body: "Outstanding support from XGenious. Incredibly fast and resolved everything on the first go. The team's technical expertise really shows — true geniuses.",
  },
  {
    name: 'Trustable',
    category: 'Design Quality',
    rating: 5,
    body: 'This script is right up there with the best in the freelance industry. Seamless user experience, exceptional functionality, and continuous improvements.',
  },
  {
    name: 'letrank69',
    category: 'Design Quality',
    rating: 5,
    body: 'Absolutely amazing script! Clean code, modern UI. Setup was smooth, performance is great, and the developer is always responsive and helpful.',
  },
  {
    name: 'rossymike',
    category: 'Design Quality',
    rating: 5,
    body: 'A complete solution that delivers everything as promised. Support has been outstanding — even when they were on holiday, they still responded promptly.',
  },
  {
    name: 'Otiumapps',
    category: 'Customer Support',
    rating: 5,
    body: 'Outstanding support and wonderful spirit. Their professionalism and dedication truly made a difference. You can feel the care they put into the product.',
  },
  {
    name: 'napster2727',
    category: 'Customer Support',
    rating: 5,
    body: 'Definitely professionals. The team knows what they are doing and the product is well built. Highly recommend to anyone looking for a freelancing platform.',
  },
  {
    name: 'fady202',
    category: 'Customer Support',
    rating: 5,
    body: 'Clean code and excellent customer support. Every question was answered quickly and thoroughly. The platform works exactly as described.',
  },
  {
    name: 'solidworld3',
    category: 'Customer Support',
    rating: 5,
    body: 'After going through the support process, I successfully launched the script. Everything works just like the demo. Very satisfied with the purchase.',
  },
  {
    name: 'larosetapark',
    category: 'Customer Support',
    rating: 5,
    body: 'The customer service is thorough and caring. Responses came with helpful visual aids and step-by-step explanations. Truly exceptional after-sale support.',
  },
  {
    name: 'rizalcyber',
    category: 'Customizability',
    rating: 5,
    body: 'Great product and great support team. They helped me customize the platform to fit my exact requirements. The codebase is clean and easy to work with.',
  },
  {
    name: 'auroravisionsrl',
    category: 'Features',
    rating: 5,
    body: 'The best product ever. Everything I needed in one package — marketplace, bidding, escrow, mobile apps. Nothing else comes close at this price point.',
  },
  {
    name: 'Roauf',
    category: 'Features',
    rating: 4,
    body: 'Solid product with great support. The foundation is excellent and the team is always improving it. Looking forward to future updates on SEO and performance.',
  },
  {
    name: 'qrud',
    category: 'Customer Support',
    rating: 5,
    body: 'Service client très réactif et professionnel. The team responded quickly to all my requests and resolved every issue. Excellent product and excellent support.',
  },
  {
    name: 'martin4bec',
    category: 'Design Quality',
    rating: 5,
    body: 'So far, the best GIG script out there. Easy to customize code as well as simple to use Dashboard for clients, freelancers and admin. Worth every penny.',
  },
];

export const FEATURES = [
  {
    title: 'Service & Gig Marketplace',
    desc: 'Freelancers post services (gigs) with packages, delivery time, revisions, and price tiers. Clients browse by category, filter by budget, and order instantly.',
  },
  {
    title: 'Project Bidding System',
    desc: 'Clients post projects with budgets and deadlines. Freelancers submit proposals. Clients review bids and hire — full Upwork-style workflow out of the box.',
  },
  {
    title: 'Escrow Payment System',
    desc: 'Client funds are held in escrow at order. Money releases to the freelancer only after the client approves the delivery. Disputes handled through admin.',
  },
  {
    title: 'Real-Time Chat & Messaging',
    desc: 'Built-in real-time messaging between clients and freelancers. File sharing, order discussion, and custom offer creation directly from the chat window.',
  },
  {
    title: 'Reviews & Ratings',
    desc: 'Mutual review system after order completion. Star ratings, written feedback, and verified buyer badge. Freelancer reputation built transparently.',
  },
  {
    title: 'Admin Panel & Analytics',
    desc: 'Full control dashboard with revenue charts, commission settings, user management, withdrawal approvals, dispute resolution, and category management.',
  },
  {
    title: 'Native Mobile App',
    desc: 'Separate Android and iOS apps for clients and freelancers. Push notifications, order management, real-time chat, and payments — all mobile-native.',
  },
  {
    title: 'Multi-Language & RTL',
    desc: 'Full translation system with RTL support. Manage all UI strings from the admin panel. Launch in any language without touching code.',
  },
  {
    title: 'Multiple Payment Gateways',
    desc: 'PayPal, Stripe, Razorpay, Flutterwave, SSLCommerz, and more. Commission rate configurable per gateway. Withdrawal to bank or wallet.',
  },
];

export const PRICING_TIERS = [
  {
    name: 'Regular License',
    badge: null as string | null,
    price: 59,
    original: 79,
    desc: 'For starting out teams building apps for many public & private users',
    plan: [
      { label: 'Xilancer Web Panel', ok: true },
      { label: 'Freelancer Mobile App', ok: false },
      { label: 'Client Mobile App', ok: false },
      { label: 'Freelancer Level Plugin', ok: false },
      { label: 'Promotional Ads Plugin', ok: false },
      { label: 'Security Plugin', ok: false },
      { label: 'Cloud Storage Plugin', ok: false },
      { label: 'Hourly Hiring Plugin', ok: false },
      { label: 'Community Plugin', ok: false },
    ],
    extras: [
      { label: 'Lifetime License Validity', ok: true },
      { label: 'Permitted for 1 Domain', ok: true },
      { label: '6 Months general & technical support (Envato Policy)', ok: true },
      { label: 'All Premium Features', ok: true },
      { label: 'Lifetime Free Update', ok: true },
      { label: 'For Personal Project', ok: true },
      { label: 'For Commercial Projects', ok: false },
      { label: 'Priority Support', ok: false },
    ],
  },
  {
    name: 'Bundle Pack',
    badge: 'Web+All Premium Plugins',
    price: 149,
    original: 199,
    desc: 'For starting out teams building apps for many public & private users',
    plan: [
      { label: 'Xilancer Web Panel', ok: true },
      { label: 'Freelancer Mobile App', ok: false },
      { label: 'Client Mobile App', ok: false },
      { label: 'Freelancer Level Plugin', ok: true },
      { label: 'Promotional Ads Plugin', ok: true },
      { label: 'Security Plugin', ok: true },
      { label: 'Cloud Storage Plugin', ok: true },
      { label: 'Hourly Hiring Plugin', ok: true },
      { label: 'Community Plugin', ok: true },
    ],
    extras: [
      { label: 'Lifetime License Validity', ok: true },
      { label: 'Permitted for 1 Domain', ok: true },
      { label: '6 Months general & technical support (Envato Policy)', ok: true },
      { label: 'All Premium Features', ok: true },
      { label: 'Lifetime Free Update', ok: true },
      { label: 'For Personal Project', ok: true },
      { label: 'For Commercial Projects', ok: true },
      { label: 'Priority Support', ok: false },
    ],
  },
  {
    name: 'Complete Package',
    badge: 'Web+App+Plugin',
    price: 282,
    original: 399,
    desc: 'For starting out teams building apps for many public & private users',
    plan: [
      { label: 'Xilancer Web Panel', ok: true },
      { label: 'Freelancer Mobile App', ok: true },
      { label: 'Client Mobile App', ok: true },
      { label: 'Freelancer Level Plugin', ok: true },
      { label: 'Promotional Ads Plugin', ok: true },
      { label: 'Security Plugin', ok: true },
      { label: 'Cloud Storage Plugin', ok: true },
      { label: 'Hourly Hiring Plugin', ok: true },
      { label: 'Community Plugin', ok: true },
    ],
    extras: [
      { label: 'Lifetime License Validity', ok: true },
      { label: 'Permitted for 1 Domain', ok: true },
      { label: '6 Months general & technical support (Envato Policy)', ok: true },
      { label: 'All Premium Features', ok: true },
      { label: 'Lifetime Free Update', ok: true },
      { label: 'For Personal Project', ok: true },
      { label: 'For Commercial Projects', ok: true },
      { label: 'Priority Support', ok: false },
    ],
  },
];
